import React, {Fragment} from 'react';

const advancedQuiz = {
    "quizTitle": "Trail Cam Quiz: Advanced",
    "questions": [
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question1.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question2.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Ermine",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question3.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question4.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Robin",
                "Hermit Thrush",
                "Veery",
                "Wood Thrush"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What is in the marten's mouth?<br /><br /><img src="/quiz-images/advanced/question5.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Woodcock",
                "Mourning Dove",
                "Rock Dove",
                "Ruffed Grouse"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question6.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Black bear",
                "Raccoon",
                "Virginia opossum",
                "Woodchuck"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question7.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Black bear",
                "Raccoon",
                "White-tailed deer",
                "Woodchuck"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question8.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Coyote",
                "Domestic dog",
                "Gray fox",
                "Red fox"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question9.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Least chipmunk",
                "Red squirrel",
                "Thirteen-lined ground squirrel"
            ],
            "correctAnswer": "1"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question10.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question11.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question12.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American marten",
                "Fisher",
                "Long-tailed weasel",
                "Mink"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question13.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Hermit Thrush",
                "Louisiana Waterthrush",
                "Ovenbird",
                "Northern Waterthrush"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question14.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American beaver",
                "Muskrat",
                "Porcupine",
                "Woodchuck"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question15.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American badger",
                "Raccoon",
                "Striped skunk",
                "Virginia opossum"
            ],
            "correctAnswer": "2"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question16.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Flying squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question17.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "American Woodcock",
                "Mourning Dove",
                "Rock Dove",
                "Ruffed Grouse"
            ],
            "correctAnswer": "4"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question18.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern fox squirrel",
                "Eastern gray squirrel",
                "Flying squirrel",
                "Red squirrel"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What animal is this?<br /><br /><img src="/quiz-images/advanced/question19.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "House mouse",
                "Meadow jumping mouse",
                "White-footed mouse",
                "Woodland jumping mouse"
            ],
            "correctAnswer": "3"
        },
        {
            "question": <Fragment>What is in the marten's mouth?<br /><br /><img src="/quiz-images/advanced/question20.jpg" alt=""></img></Fragment>,
            "questionType": "text",
            "answers": [
                "Eastern chipmunk",
                "Flying squirrel",
                "White-footed mouse",
                "Norway rat"
            ],
            "correctAnswer": "2"
        },
    ]
}

export default advancedQuiz;


// WEBPACK FOOTER //
// ./src/quiz/advancedQuiz.js